import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import IBigDataCorpFilter from "../interface/bigdatacorp/IBigDataCorpFilter";

enum BigDataCorpServiceEnum {
  GetLasResearchesByFilters = "/get-last-researches-by-filters",
  createQueryByFilters = "/create-query-by-filter"
}

export default class BigDataCorpService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/bigdatacorp");
  }

  public getLasResearchesByFlters = async (filter: IBigDataCorpFilter) => await this.POST(BigDataCorpServiceEnum.GetLasResearchesByFilters, filter);
  public createQueryByFilters = async (filter: IBigDataCorpFilter) => await this.POST(BigDataCorpServiceEnum.createQueryByFilters, filter);
}
